import { css } from '@emotion/react'
import { Button } from '@ruguoapp/jike-fe-components'
import { BubbleIcon } from '@ruguoapp/jike-fe-icons'
import { isEmpty } from 'lodash-es'
import type { HTMLAttributes } from 'react'
import { Controller, useWatch } from 'react-hook-form'
import type { RepostFormValue } from './types'

export interface SubmitButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
	isLoading?: boolean
}

export default function SubmitButtonGroup({ isLoading, ...props }: SubmitButtonGroupProps) {
	const content = useWatch<RepostFormValue, 'content'>({
		name: 'content',
	})
	const syncComment = useWatch<RepostFormValue, 'syncComment'>({
		name: 'syncComment',
	})
	const isDisabled = syncComment ? isEmpty(content) : false
	return (
		<div
			css={css`
				display: flex;
				align-items: center;
				gap: 10px;
			`}
			{...props}
		>
			<Controller
				name="syncComment"
				render={({ field }) => (
					<Button
						onClick={() => field.onChange(!field.value)}
						appearance={field.value ? 'primary' : 'ghost'}
						css={css`
							&.jk-btn {
								min-width: unset;
								border-radius: 50%;
								padding: 4px;
								aspect-ratio: 1;
							}
						`}
						size="sm"
					>
						<BubbleIcon
							css={css`
								width: 16px;
								height: 16px;
							`}
							color="currentColor"
						/>
					</Button>
				)}
			/>

			<Button
				appearance="primary"
				size="sm"
				type="submit"
				disabled={isLoading || isDisabled}
				loading={isLoading}
			>
				转发动态{syncComment && '并评论'}
			</Button>
		</div>
	)
}
